import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		header: {
			marginBottom: theme.spacing(3),
		},
		title: {
			display: "flex",
			alignItems: "center",
			gap: theme.spacing(1),
		},
		content: {
			backgroundColor: "white",
			borderRadius: 4,
			padding: theme.spacing(3),
		},
		placeholder: {
			textAlign: "center",
			color: theme.palette.text.secondary,
			padding: theme.spacing(4),
		},
		componentGrid: {
			marginTop: theme.spacing(3),
		},
		componentCard: {
			padding: theme.spacing(2),
			textAlign: "center",
			height: "100%",
		},
	} satisfies Record<string, CSSObject>;
};